import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoLink from 'eco-design/base/eco-link';
import { useRouter } from 'next/router';
import { useInViewport } from 'ahooks';
import gtm from '@/utils/gtm';

interface TabType {
    tab: string;
    id: string;
}

interface TabProps {
    loaded?: boolean;
}

const Tab: React.FC<TabProps> = ({ loaded }) => {
    const { t } = useLang('rapidpro');
    const [active, setActive] = useState(0);
    const { locale = 'us' } = useRouter();
    const IS_EU: boolean = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    let tabs: TabType[] = [];
    if (locale === 'ph') {
        tabs = [
            {
                tab: t('Tab_text1'),
                id: 'F',
            },
            {
                tab: t('Tab_text3'),
                id: 'H',
            },
            {
                tab: t('Tab_text4'),
                id: 'I',
            },
        ];
    } else {
        tabs = [
            {
                tab: t('Tab_text1'),
                id: 'F',
            },
            {
                tab: t('Tab_text2'),
                id: 'G',
            },
            {
                tab: t('Tab_text3'),
                id: 'H',
            },
            {
                tab: t('Tab_text4'),
                id: 'I',
            },
        ];
    }

    const handleChangeTab = (k: number) => {
        setActive(k);
        gtm.push({
            __btn_id1: `rapid-pro-Tab .tab-${k + 1}`,
            __btn_id2: tabs[k].tab,
            __btn_type: 'text',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && window?.AniContainer) {
            const aniScroll = (id: string, k: number) => {
                const scene = AniContainer.create({
                    triggerElement: `#rapid-pro-${id}`,
                    triggerHook: 1,
                    offset: window.innerHeight / 2,
                    onEnter: () => setActive(k),
                });
                return () => {
                    scene.destroy();
                };
            };
            tabs.map((tab: TabType, k: number) => aniScroll(tab.id, k));
        }
    }, []);

    const [inViewport] = useInViewport(() => document.getElementById('rapid-pro-E'));

    return (
        <div className={`rapid-pro-Tab GtmModuleData-section ${css.section}`} data-section-id={'rapid-pro-Tab'} style={{ opacity: !inViewport ? 1 : 0 }}>
            <ul className={`tabs${IS_EU ? ' eu' : ''}`}>
                {tabs?.map((tab: TabType, k: number) => (
                    <li className={`tab tab-${k + 1} GtmModuleData-btn-text ${active === k ? ' active' : ''}`} key={k} onClick={() => handleChangeTab(k)}>
                        <EcoLink href={`#rapid-pro-${tab.id}`}>{tab.tab}</EcoLink>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Tab;
